import {
	FC,
	InputHTMLAttributes,
	ChangeEvent,
	useEffect,
	useState,
} from 'react'
import cn from 'classnames'

import styles from './Input.pcss'

interface Props extends InputHTMLAttributes<HTMLInputElement> {
	pattern?: string
	onChange?: (e: ChangeEvent<HTMLInputElement>) => void
}

const Input: FC<Props> = ({
	pattern,
	onChange = () => {},
	className,
	...rest
}) => {
	const [value, setValue] = useState('')
	const [invalid, setInvalid] = useState(false)
	const regexp = new RegExp(pattern)

	const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
		if (regexp.test(event.target.value)) {
			onChange(event)
			setValue(event.target.value)
		} else {
			setInvalid(true)
		}
	}

	useEffect(() => {
		if (invalid) {
			setTimeout(() => {
				setInvalid(false)
			}, 100)
		}
	}, [invalid])

	return (
		<input
			className={cn(styles.input, className, invalid && styles.invalid)}
			type="text"
			pattern={pattern}
			value={value}
			onChange={handleChange}
			{...rest}
		/>
	)
}

export default Input
